import { create } from 'zustand';
import { getSubjectLecturesAPI, quizMcqsAPI } from '../API';

const useStudentLectureStore = create((set) => ({
  lectures: [],
  mcqs: [],
  count: 0,
  loading: false,
  error: null,

  teacherEmail: '',
  subject: '',
  chapterName: '',
  className: '',

  setQuizInfo: ({ teacherEmail, subject, chapterName, className }) =>
    set({ teacherEmail, subject, chapterName, className }),

  resetQuizInfo: () => set({ teacherEmail: '', subject: '', chapterName: '', className: '' }),

  fetchLectures: async ({ className, subject, teacherEmail, teacherName, studentEmail }) => {
    set({ loading: true, error: null });

    try {
      const response = await getSubjectLecturesAPI({
        className,
        subject,
        teacherEmail,
        teacherName,
        studentEmail
      });

      set({ lectures: response?.data?.lectures || [], count: response?.data?.count, loading: false });
    } catch (err) {
      set({ error: err.message || 'Failed to fetch lectures', loading: false });
      console.error('Fetch lectures error:', err);
    }
  },

  fetchQuizMcqs: async({teacherEmail, subject, chapterName, className }) => {
   set({ loading: true, error: null });
    try {
       const response = await quizMcqsAPI({
         teacherEmail, subject, chapterName, className
      });

      set({ mcqs: response?.data?.mcqs || [], loading: false });
    } catch (err) {
       set({ error: err.message || 'Failed to fetch lectures', loading: false });
       console.error('Fetch lectures error:', err);
    }
  },

  resetLectures: () => set({ lectures: [], loading: false, error: null }),
}));

export default useStudentLectureStore;
